// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCamera = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M12 17a4 4 0 100-8 4 4 0 000 8m2-4a2 2 0 11-4 0 2 2 0 014 0" />,
    <path fillRule="evenodd" d="M7 6l2-2h6l2 2h5v14H2V6zm2.828 0h4.344l2 2H20v10H4V8h3.828z" />
  );
export default SvgIconCamera;
